import React, { ReactElement, useEffect, useState } from 'react'
import { Table, Popover, ConfigProvider } from 'antd'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import zhCN from 'antd/es/locale/zh_CN'
import { getUuid } from '@/utils/util'
import { getErrorStr } from '@/store/sagas/table.saga'
import { requestFail } from '@/store/actions/common.action'
import { getOnlineReviewTMT } from '@/services/progress.service'

const FeedbackTable = (props: {
    idProp?: string
    list?: any[]
}): ReactElement => {
    const { idProp, list } = props
    const { t, i18n } = useTranslation()
    const dispatch = useDispatch()
    // 已反馈用户列表
    const [feedbackList, setFeedbackList] = useState<any[]>([])

    const columns = [
        {
            title: () => <span>{t('feedbackName')}</span>,
            dataIndex: 'creatorName',
            key: 'creatorName',
            width: 150,
            ellipsis: { showTitle: true },
        },
        {
            title: () => <span>{t('WorkGroup')}</span>,
            dataIndex: 'workGroup',
            key: 'workGroup',
            width: 150,
            ellipsis: { showTitle: true },
            render (value: any) {
                return value?.workGroupName || ''
            }
        },
        {
            title: () => <span>{t('isRelevant')}</span>,
            dataIndex: 'isRelevant',
            key: 'isRelevant',
            width: 100,
            ellipsis: { showTitle: true },
            // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
            render (value: boolean, record: any) {
                if (record.auditOrNot) {
                    return <span>{t('sitInOn')}</span>
                } else {
                    if (value !== null) {
                        if (value) {
                            return <span>{t('Yes')}</span>
                        }
                        return <span>{t('No')}</span>
                    } else {
                        return <></>
                    }
                }
            }
        },
        {
            title: () => <span>{t('tmtUser')}</span>,
            dataIndex: 'tmtInfos',
            key: 'tmtInfos',
            width: 150,
            ellipsis: { showTitle: true },
            render (value: any[]) {
                return value?.map(item => item.tmtFullUser).join(',') || ''
            }
        },
        {
            title: () => <span>{t('description')}</span>,
            dataIndex: 'description',
            key: 'description',
            width: 150,
            ellipsis: { showTitle: true },
            render (value: string) {
                return <Popover 
                    placement="topLeft"
                    title=""
                    content={
                        <div style={{ maxWidth: 240, maxHeight: 300, overflowY: 'auto', wordBreak: 'break-all' }}
                            dangerouslySetInnerHTML={{
                                __html: value ? ((value.includes('"str":') || value.includes('"obj":')) ? JSON.parse(value)?.str : value) : ''
                            }}
                        ></div>
                    }
                >
                    <div style={{ maxWidth: 240 }}
                        className='table_ellipsis'
                        dangerouslySetInnerHTML={{
                            __html: value ? ((value.includes('"str":') || value.includes('"obj":')) ? JSON.parse(value)?.str : value) : ''
                        }}
                    ></div>
                </Popover>
            }
        },
    ]

    const getFeedbackTMTLs = async (id: string) => {
        try {
            const res = await getOnlineReviewTMT(+id)
            setFeedbackList(res)
        } catch (error: any) {
            const str = getErrorStr(error)
            dispatch(requestFail(str))
        }
    }

    useEffect(() => {
        console.log('list: ', list)
        if (idProp !== undefined) {
            getFeedbackTMTLs(idProp)
        } else if (list) {
            setFeedbackList(list)
        }
    }, [list])

    return (
        <ConfigProvider locale={i18n.language === 'zh' ? zhCN : undefined}>
            <Table bordered
                key={getUuid(8)}
                dataSource={feedbackList}
                columns={columns}
                rowKey="key"
                pagination={false}
            ></Table>
        </ConfigProvider>
    )
}

export default FeedbackTable